export default "__VITE_ASSET__2WJ3ToMr__"